export const PersonTypeBadge = ({ tipo, testId }) => {
  const pf = tipo === "PF";
  return (
    <span data-testid={testId} title={pf ? "Pessoa Física" : "Pessoa Jurídica"}
      className={`inline-flex items-center rounded border px-1.5 py-0.5 text-[10px] font-bold tracking-wider ${pf ? "border-sky-400/40 bg-sky-400/10 text-sky-300" : "border-amber-400/40 bg-amber-400/10 text-amber-300"}`}>
      {pf ? "PF" : "PJ"}
    </span>
  );
};
